import { generateApiRoute } from '@klp/core/api/helpers';

import { baseApi } from '@klp/core/api';
import { byggApiName, byggFavorittApiName } from '../config';
import type { Bygg } from '@forvalter/types/ForvalterCommonDAL';

export type IByggList = Array<Bygg>;

export const contextSelectorApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getByggList: build.query<
            Array<Bygg>,
            { ansvarlig?: string; includeAll?: boolean }
        >({
            query: ({ ansvarlig, includeAll }) => ({
                url: generateApiRoute([byggApiName]),
                params: { ansvarlig, includeAll },
                method: 'GET',
            }),
            providesTags: ['ByggFavoritter'],
        }),
        getBygg: build.query<IByggList, { byggNummer: string }>({
            query: ({ byggNummer }) => ({
                url: generateApiRoute([byggApiName, byggNummer]),
                method: 'GET',
            }),
        }),
        postFavoritt: build.mutation<Bygg, { byggNummer: string }>({
            query(data) {
                return {
                    url: generateApiRoute([byggApiName, byggFavorittApiName]),
                    method: 'POST',
                    body: data,
                };
            },
            invalidatesTags: ['ByggFavoritter', 'frontpageAggregate'],
        }),
        deleteFavoritt: build.mutation<Bygg, { favorittId: number }>({
            query({ favorittId }) {
                return {
                    url: generateApiRoute([
                        byggApiName,
                        byggFavorittApiName,
                        favorittId,
                    ]),
                    method: 'DELETE',
                };
            },
            invalidatesTags: ['ByggFavoritter', 'frontpageAggregate'],
        }),
    }),
});

export const {
    useGetByggQuery,
    useLazyGetByggQuery,
    useGetByggListQuery,
    useLazyGetByggListQuery,
    useDeleteFavorittMutation,
    usePostFavorittMutation,
} = contextSelectorApi;
